<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eMTFT3/tc-custom/FC-9781528961752.jpg?1685327176233?1725650245689" alt="This image is the cover for the book The Gatekeeper/s"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Gatekeeper/s
      </h1>
      <p class="bookDescription body article font2">
        <p>The Gatekeeper/s blends realism and idealism in a novel way. The style is also unusual in that it moves from rhetorical dialogue to emphatic storytelling. The story is set against a legal system based on seeking consent between parties involved in a negotiation, rather than regarding one party wrong and the other right, as in the old legal system. Rhetoricians are the ones expected to obtain consent from people and they act on behalf of GAIC (Global Authority for Informed Consent) and its negotiators. The main rhetorician is Toni Forti. Achilles is the main negotiator. There are two groups of children interacting with GAIC. In the first part of the story, three children separately challenge the new informed consent to achieve self-determination. In the second part of the story, four children use the system to achieve justice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michela Arturina Betta
      </h2>
      
      <p class="authorDescription body article">Michela Arturina Betta was born in Italy. She went to school in Riva del Garda and to university in Milan and Frankfurt. Here she completed her studies and received her PhD in philosophy. Afterward, she travelled to Melbourne where she worked as an academic for several years. In 2018, she moved to Stockholm where she is currently living. She has written several fiction books in Italian and English.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a995cb6